import React from 'react';

const Quote = ({ imageSrc, text, author, quotesIcon }) => {
  return (
    <div
      className="bg-gradient-to-br w-dvw from-gray-800 to-gray-900 flex relative max-w-xl lg:my-auto mx-12 rounded-2xl my-4 quote
     hover:shadow-violet-900 shadow-violet-950 shadow-lg"
    >
      <img
        className="ml-8 mt-8 mr-5 h-[40px] sm:h-[50px] lg:h-[60px] xl:h-[90px] w-[40px] sm:w-[50px] lg:w-[60px] xl:w-[90px] rounded-full"
        src={imageSrc}
        alt=""
      />
      <div className="mt-10 mb-16">
        <img className="h-6 inline mr-3" src={quotesIcon} alt="Quotes icon" />
        <p className="inline max-w-[80%] italic text-base xl:text-lg text-gray-300 pr-10">
          {text}
        </p>
      </div>
      <p className="absolute bottom-6 text-white right-12 text-lg xl:text-xl font-semibold">
        - {author}
      </p>
    </div>
  );
};

export default Quote;
